export function isInIframe(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function getApiBaseUrl(): string {
  if (isInIframe()) return "/proxy";
  return process.env.NEXT_PUBLIC_BACKEND_URL ?? "";
}
